<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mr-3 mb-3 align-self-center">Checkout<v-icon right>shopping_cart</v-icon></h1>
                <p class="error--text font-weight-bold">Disclaimer: The {{ appNameUrls.client }} online platform is a "first to checkout" online system. While every effort is made to ensure customers receive products in their shopping cart, products may be sold out before reaching the payment window.</p>
                <p class="font-italic">All fields marked * are mandatory.</p>
                <p class="secondary--text text--lighten-1 font-weight-bold" v-if="(!shoppingCartAKV && shoppingCartCount > 1) || (shoppingCartAKV && shoppingCartCount > 1)">
                    An Active & Creative Kids Voucher (AKV) cannot be redeemed when purchasing multiple products. If you wish to use an AKV please purchase eligible product separately.
                </p>
                <!-- <p class="secondary--text text--lighten-1 font-weight-bold" v-if="anyShoppingCartNoAttendee && shoppingCartCount > 1">
                    One of the purchased product does not required attendees information. You need to purchase it separately.
                </p> -->

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlay = false"
                                >Close
                                <v-icon medium right>highlight_off</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <v-stepper v-model.lazy="checkoutStep" vertical>
                    <v-stepper-step :editable="editablePanel" :complete="checkoutStep > 1" step="1" :color="checkoutStep > 1 ? 'success' : 'primary'">
                        Cart
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-form class="overwrite-inputs" data-vv-scope="step1" lazy-validation>
                            <v-list>
                                <v-list-item class="pa-0" v-for="(item, index) in shoppingCart" :key="'chk_' + index">
                                    <v-list-item-content>
                                        <v-list-item-title v-html="item.product_title"></v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div class="secondary--text text--darken-4">
                                                Total:
                                                {{ item.product_totalPrice | currency }}
                                                - Quantity:
                                                {{ item.product_quantity }}
                                                <v-btn class="upd_qty" small :disabled="item.product_quantity >= item.product_order_qty_max" @click.native="addProductQuantity(item)"><v-icon small color="primary">add</v-icon></v-btn>
                                                <v-btn class="upd_qty" small @click.native="removeProductQuantity(item)"> <v-icon small color="primary">remove</v-icon></v-btn>
                                            </div>
                                            <div class="primary--text text--darken-4 mt-1" v-html="showVoucherEligibility(item.product_akv)"></div>
                                            <div class="primary--text text--darken-4 mt-1" v-html="showAttendeeEligibility(item.product_no_attendee)"></div>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-btn icon ripple @click.native="removeProduct(item)">
                                        <v-icon class="red--text text--lighten-1">delete</v-icon>
                                    </v-btn>
                                </v-list-item>
                            </v-list>

                            <v-simple-table class="mt-3">
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Subtotal ({{
                                                    shoppingCartCount
                                                        | pluralize("item", {
                                                            includeNumber: true,
                                                        })
                                                }}):
                                            </td>
                                            <td class="text-xs-right">
                                                <span>{{ subTotal | currency("$") }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tax:</td>
                                            <td class="text-xs-right">
                                                <span>{{ taxTotal | currency("$") }}</span>
                                            </td>
                                        </tr>
                                        <tr v-if="discountTotal > 0">
                                            <td>Discount:</td>
                                            <td class="text-xs-right">
                                                <span>{{ discountTotal | currency("$") }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Grand Total:</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong
                                                    ><span>{{ grandTotal | currency("$") }}</span></strong
                                                >
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>

                            <div class="mt-4">
                                <v-btn color="primary" :disabled="shoppingCartCount < 1" @click.native="submitStep('step1')">Continue</v-btn>
                            </div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step2')]"
                        :editable="editablePanel"
                        :complete="checkoutStep > 2"
                        step="2"
                        :color="checkoutStep > 2 ? 'success' : 'primary'"
                    >
                        Attendees
                        <small v-if="!shoppingCartNoAttendee" class="secondary--text text--lighten-1 font-weight-bold">
                            <v-icon color="secondary lighten-1" small left>info_outline</v-icon>Fill in attendees information
                        </small>
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <v-form class="overwrite-inputs" data-vv-scope="step2" lazy-validation>
                            <input type="hidden" v-validate:length="'min_value:1'" name="attendees_list" />
                            <v-card v-if="!shoppingCartNoAttendee" color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <!-- <div v-if="attendeeSize < 1" class="red--text lighten-1 mb-4 caption font-weight-bold"><v-icon color="red lighten-1" small left style="margin-top: -4px;">info</v-icon>Minimum {{minShoppingCartQty | pluralize('attendee', { includeNumber: true })}}, Maximun {{shoppingCartQty | pluralize('attendee', { includeNumber: true })}}</div> -->
                                <v-divider v-if="attendeeSize < 1" light class="my-3"></v-divider>
                                <div v-for="(attendee, index) in attendees" :key="index">
                                    <v-layout row wrap align-end class="pa-0">
                                        <v-flex xs12 sm12 md12>
                                            Attendee #{{ index + 1 }}
                                            <span v-if="attendee.click && attendee.confirm">
                                                Added - {{ attendee.firstname }}
                                                {{ attendee.lastname }}
                                                <v-btn color="error" small outlined @click="removeAttendee(index)" class="my-3 my-sm-0 mx-sm-6 mx-0 mob-block"
                                                    ><v-icon dark small left>remove_circle</v-icon> Remove Attendee</v-btn
                                                >
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap align-end class="pa-0" v-if="!(attendee.click && attendee.confirm)">
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                :disabled="attendee.confirm"
                                                prepend-icon="person"
                                                label="Firstname*"
                                                v-model.lazy.trim="attendee.firstname"
                                                v-validate="'required'"
                                                :error="errors.has('attendee.firstname_' + index)"
                                                :error-messages="errors.collect('attendee.firstname_' + index)"
                                                :name="'attendee.firstname_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                :disabled="attendee.confirm"
                                                prepend-icon="person"
                                                label="Lastname*"
                                                v-model.lazy.trim="attendee.lastname"
                                                v-validate="'required'"
                                                :error="errors.has('attendee.lastname_' + index)"
                                                :error-messages="errors.collect('attendee.lastname_' + index)"
                                                :name="'attendee.lastname_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-select
                                                :disabled="attendee.confirm"
                                                prepend-icon="perm_identity"
                                                :items="gender"
                                                label="Gender*"
                                                v-model.lazy.trim="attendee.gender"
                                                v-validate="'required'"
                                                :error="errors.has('attendee.gender_' + index)"
                                                :error-messages="errors.collect('attendee.gender_' + index)"
                                                :name="'attendee.gender_' + index"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                :disabled="attendee.confirm"
                                                prepend-icon="event"
                                                v-mask="'##/##/####'"
                                                hint="dd/mm/yyyy"
                                                persistent-hint
                                                label="Date of Birth*"
                                                v-model.lazy.trim="attendee.dob"
                                                v-validate="'required|date_format:dd/MM/yyyy'"
                                                :error="errors.has('attendee.dob_' + index)"
                                                :error-messages="errors.collect('attendee.dob_' + index)"
                                                :name="'attendee.dob_' + index"
                                            ></v-text-field>
                                        </v-flex>

                                        <!--// exrtra fields //-->
                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                :disabled="attendee.confirm"
                                                label="Email*"
                                                prepend-icon="email"
                                                v-model.lazy.trim="attendee.email"
                                                v-validate.initial="attendee.requireInfo ? 'required|email' : ''"
                                                :error="errors.has('attendee.email_' + index)"
                                                :error-messages="errors.collect('attendee.email_' + index)"
                                                :name="'attendee.email_' + index"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                label="Mobile*"
                                                prepend-icon="smartphone"
                                                v-model.lazy.trim="attendee.mobile"
                                                v-mask="'##########'"
                                                hint="e.g. 0412345678"
                                                persistent-hint
                                                v-validate.initial="attendee.requireInfo ? 'required|min:10' : ''"
                                                :error="errors.has('attendee.mobile_' + index)"
                                                :error-messages="errors.collect('attendee.mobile_' + index)"
                                                :name="'attendee.mobile_' + index"
                                                maxlength="10"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                label="Address*"
                                                prepend-icon="location_city"
                                                v-model.lazy.trim="attendee.address"
                                                v-validate.initial="attendee.requireInfo ? 'required' : ''"
                                                :error="errors.has('attendee.address_' + index)"
                                                :error-messages="errors.collect('attendee.address_' + index)"
                                                :name="'attendee.address_' + index"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-autocomplete
                                                cache-items
                                                :items="localities"
                                                persistent-hint
                                                hint="Type 2 or more characters"
                                                label="Suburb*"
                                                prepend-icon="location_city"
                                                v-model.lazy.trim="attendee.suburb"
                                                @change="setLocation(attendee.suburb, index)"
                                                v-validate.initial="attendee.requireInfo ? 'required' : ''"
                                                :error="errors.has('attendee.suburb_' + index)"
                                                :error-messages="errors.collect('attendee.suburb_' + index)"
                                                :name="'attendee.suburb_' + index"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                label="Postcode*"
                                                prepend-icon="location_on"
                                                v-model.lazy.trim="attendee.postcode"
                                                v-validate.initial="attendee.requireInfo ? 'required' : ''"
                                                :error="errors.has('attendee.postcode_' + index)"
                                                :error-messages="errors.collect('attendee.postcode_' + index)"
                                                :name="'attendee.postcode_' + index"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-autocomplete
                                                cache-items
                                                :items="states"
                                                item-text="text"
                                                item-value="value"
                                                label="State*"
                                                prepend-icon="location_on"
                                                v-model.lazy.trim="attendee.state"
                                                v-validate.initial="attendee.requireInfo ? 'required' : ''"
                                                :error="errors.has('attendee.state_' + index)"
                                                :error-messages="errors.collect('attendee.state_' + index)"
                                                :name="'attendee.state_' + index"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 v-if="attendee.requireInfo">
                                            <v-input prepend-icon="contact_phone" :messages="['Enter emergency contact information']">Emergency Contact(s)</v-input>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                label="Contact Fullname*"
                                                prepend-icon="person"
                                                v-model.trim="attendee.ec_fullname"
                                                v-validate.initial="attendee.requireInfo ? 'required' : ''"
                                                :error="errors.has('attendee.ec_fullname_' + index)"
                                                :error-messages="errors.collect('attendee.ec_fullname_' + index)"
                                                :name="'attendee.ec_fullname_' + index"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 v-if="attendee.requireInfo">
                                            <v-text-field
                                                label="Contact Mobile*"
                                                prepend-icon="phone"
                                                v-model.trim="attendee.ec_mobile"
                                                v-mask="'##########'"
                                                hint="e.g. 0412345678"
                                                persistent-hint
                                                v-validate.initial="attendee.requireInfo ? 'required|min:10|max:10' : ''"
                                                :error="errors.has('attendee.ec_mobile_' + index)"
                                                :error-messages="errors.collect('attendee.ec_mobile_' + index)"
                                                :name="'attendee.ec_mobile_' + index"
                                                maxlength="10"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 v-if="attendee.requireInfo">
                                            <v-input prepend-icon="local_hospital" :messages="['Enter any medical conditions or allergies']"
                                                >Medical Conditions / Allergies</v-input
                                            >
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 v-if="attendee.requireInfo">
                                            <v-textarea outlined v-model.trim="attendee.ec_medical" auto-grow></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6 class="text-left">
                                            <v-btn
                                                :color="attendee.requireInfo ? 'red white--text' : 'success white--text'"
                                                :disabled="attendee.click && attendee.confirm"
                                                small
                                                @click="checkAttendee(index)"
                                                class="mt-3 mb-5 mx-0 mob-block"
                                                v-model.lazy.trim="attendee.click"
                                                v-validate="'required:true'"
                                                :error="errors.has('attendee.click_' + index)"
                                                :name="'attendee.click_' + index"
                                                ><v-icon dark small left>{{ attendee.requireInfo ? "how_to_reg" : "person_add" }}</v-icon
                                                >{{ attendee.btn }}</v-btn
                                            >
                                            <span class="caption red--text text--darken-1" v-if="attendee.status && attendee.status != 'Attendee Found'">{{
                                                attendee.status
                                            }}</span>
                                            <span v-if="errors.has('attendee.click_' + index)" class="caption red--text text--darken-1"
                                                ><br />Must click "CONFIRM Attendee" button</span
                                            >
                                        </v-flex>
                                        <v-flex xs12 sm3 md3 class="text-right">
                                            <v-btn color="error" small outlined @click="removeAttendee(index)" class="my-3 mx-0 mob-block"
                                                ><v-icon dark small left>remove_circle</v-icon> Remove Attendee</v-btn
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-divider light class="my-3"></v-divider>
                                </div>
                                <v-btn class="ma-3" color="secondary" small :disabled="attendeeSize >= shoppingCartQty" @click="addAttendee"
                                    ><v-icon dark small left>add_circle</v-icon>ADD Attendee</v-btn
                                >
                            </v-card>
                            <v-card v-if="shoppingCartNoAttendee" color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <p class="secondary--text text--lighten-1 font-weight-bold">No Attendees information required.</p>
                            </v-card>
                            <v-btn
                                v-if="!shoppingCartNoAttendee"
                                color="primary"
                                @click.native="submitStep('step2')"
                                :disabled="errors.any('step2') || attendeeSize < minShoppingCartQty || attendeeSize > shoppingCartQty"
                                >Continue</v-btn
                            >
                            <v-btn
                                v-if="shoppingCartNoAttendee"
                                color="primary"
                                @click.native="submitStep('step2')"
                                :disabled="errors.any('step2')"
                                >Continue</v-btn
                            >
                            <v-btn color="error" text @click.native="checkoutStep = 1">Back</v-btn>
                            <div v-if="errors.any('step2')" class="red--text text--lighten-1">
                                Please check the form above for errors.
                            </div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step3')]"
                        :editable="editablePanel"
                        :complete="checkoutStep > 3"
                        step="3"
                        :color="checkoutStep > 3 ? 'success' : 'primary'"
                    >
                        Assign Attendees
                        <small v-if="!shoppingCartNoAttendee" class="secondary--text text--lighten-1 font-weight-bold">
                            <v-icon color="secondary lighten-1" small left>info_outline</v-icon>Assign attendees
                        </small>
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <v-form class="overwrite-inputs" data-vv-scope="step3" lazy-validation>
                            <v-card v-if="!shoppingCartNoAttendee" color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <v-list class="pa-2">
                                    <v-list-item class="pa-0" v-for="(item, pdtIndex) in shoppingCart.filter(o => !o.product_no_attendee)" :key="'pdt_' + pdtIndex">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-icon color="secondary" left>sports_basketball</v-icon>
                                                #{{ pdtIndex + 1 }} -
                                                {{ item.product_title }}
                                                <small class="d-block ml-10 mb-4 secondary--text text--darken-4 font-weight-bold"
                                                    ><v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">group</v-icon>Quantity:
                                                    {{ item.product_quantity }}</small
                                                >
                                            </v-list-item-title>
                                            <div v-for="(attendee, attIndex) in attendees" :key="'pdt_' + pdtIndex + '_att_' + attIndex">
                                                <v-switch
                                                    class="ma-0 pt-0 pa-0 pl-10"
                                                    inset
                                                    :label="`${attendee.firstname} ${attendee.lastname}`"
                                                    color="secondary"
                                                    @change="assignAttendee(item.product_id, attIndex, $event)"
                                                ></v-switch>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <input
                                    type="hidden"
                                    v-model.trim="assignSize"
                                    v-validate="'required|min_value:' + minShoppingCartQty + '|max_value:' + shoppingCartQty"
                                    :name="'assignSize'"
                                />
                                <input type="hidden" v-model.trim="assignPerProduct" v-validate="'required: true'" :name="'assignPerProduct'" />
                            </v-card>
                             <v-card v-if="shoppingCartNoAttendee" color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <p class="secondary--text text--lighten-1 font-weight-bold">No Attendees information required.</p>
                             </v-card>
                            <v-btn color="primary" @click.native="submitStep('step3')" :disabled="errors.any('step3')">Continue</v-btn>
                            <v-btn color="error" text @click.native="checkoutStep = 2">Back</v-btn>
                            <div v-if="errors.any('step3')" class="red--text text--lighten-1">
                                Please check the form above for errors.
                            </div>
                            <div v-if="!shoppingCartNoAttendee && (errors.has('assignSize', 'step3') || errors.has('assignPerProduct', 'step3'))" class="red--text text--lighten-1">
                                Assign attendees do not match products quantity purchased
                            </div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step :editable="editablePanel" :complete="checkoutStep > 4" step="4" :color="checkoutStep > 4 ? 'success' : 'primary'">
                        Checkout Review
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-form class="overwrite-inputs" data-vv-scope="step4" lazy-validation>
                            <v-card color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <v-list>
                                    <v-list-item class="pl-3" v-for="(item, index) in shoppingCart" :key="'chk_' + index">
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.product_title"></v-list-item-title>
                                            <v-list-item-subtitle>
                                                <div class="secondary--text text--darken-4">
                                                    Total:
                                                    {{ item.product_totalPrice | currency }}
                                                    &nbsp; - &nbsp; Quantity:
                                                    {{ item.product_quantity }}
                                                </div>
                                                <div class="primary--text text--lighten-1 mt-1" v-if="!shoppingCartNoAttendee && viewAssignAttendee(item.product_id)">
                                                    Attendee(s):
                                                    {{ viewAssignAttendee(item.product_id) | capitalize }}
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <v-flex xs12 sm12 md12 class="my-2">
                                    <v-card hover>
                                        <v-card-text class="">
                                            <span v-cloak v-if="!isAdult"
                                                ><strong>Where the applicant(s) is under 18 years of age the below box must be ticked by the applicant's parent or guardian.</strong
                                                ><br />You are the parent or guardian of the applicant(s). </span
                                            >By ticking this box you authorise and consent to the applicant(s) to attend the selected {{ appNameUrls.assoc_name }} event and release
                                            the Association, its directors, employees and casual staff from all liability arising out of the attendance. Should at any time
                                            {{ appNameUrls.assoc_inc }} consider that the listed attendee(s) require medical, dental or hospital assistance and
                                            {{ appNameUrls.assoc_inc_short }} are unable to contact the emergency contact at the numbers provided, I consent to
                                            {{ appNameUrls.assoc_inc_short }} obtaining assistance at my expense I give permission for the attendee(s) to be photographed during the
                                            {{ appNameUrls.assoc_inc_short }} event. Photos may be utilised for website and promotional purposes. Personal information will not
                                            accommpany the photograph if published. I have read and agree to the
                                            <a href="/about/policy-procedures/" target="_new">Conditions of Entry,</a>
                                            <a href="/about/policy-procedures/" target="_new">Refund Policy</a> and
                                            <a href="/about/policy-procedures/" target="_new">Product Waiver</a>
                                            <v-checkbox
                                                class="mt-1 chk-label"
                                                v-model.lazy.trim="agreed"
                                                v-validate="'required:true'"
                                                :error="errors.has('agreed')"
                                                :error-messages="errors.collect('agreed')"
                                                :name="'agreed'"
                                            >
                                                <template v-slot:label>
                                                    <div class="">
                                                        I agree
                                                        <span v-cloak v-if="!isAdult">on behalf of the applicant(s)</span>
                                                        to the Conditions of Entry, Refund Policy and Product Waiver.
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>

                                <v-simple-table class="mt-1">
                                    <template v-slot:default>
                                        <tbody>
                                            <tr v-if="couponApplied">
                                                <td style="width: 100%;">
                                                    <strong><span v-if="shoppingCartAKV && shoppingCartCount == 1">Enter Active & Creative Kids / </span> {{ appNameUrls.client }} Voucher </strong>
                                                    <v-btn v-if="couponApplied" small dark color="red" @click="removeVoucher">remove</v-btn>
                                                </td>
                                                <td class="text-xs-right">
                                                    <strong><span>{{ discountTotal | currency("$") }}</span></strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="width: 100%;">
                                                    <strong>Grand Total:</strong>
                                                </td>
                                                <td class="text-xs-right">
                                                    <strong><span>{{ grandTotal | currency("$") }}</span></strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                            <v-btn v-if="!couponApplied" color="primary" @click.native="submitStep('step4')" :disabled="errors.any('step4')">Continue</v-btn>
                            <v-btn
                                v-if="couponApplied"
                                color="primary"
                                @click="submitStep('step'+lastStep)"
                                :disabled="errors.any('step4')"
                                >Continue</v-btn
                            >

                            <v-btn color="error" text @click.native="checkoutStep = 3">Back</v-btn>
                            <div v-if="errors.any('step4')" class="red--text text--lighten-1">
                                Please check the form above for errors.
                            </div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        v-if="/*shoppingCartAKV &&*/ shoppingCartCount >= 1"
                        :rules="[() => !couponErrors.any()]"
                        :complete="checkoutStep > 5 || couponApplied"
                        step="5"
                        :color="checkoutStep > 5 || couponApplied ? 'success' : 'primary'"
                        :editable="editablePanel"
                    >
                        <div><span v-if="shoppingCartAKV && shoppingCartCount == 1">Enter Active & Creative Kids / </span> {{ appNameUrls.client }} Voucher</div>
                        <small>{{ getCouponMessage }}</small>
                    </v-stepper-step>

                    <v-stepper-content step="5" v-if="/*shoppingCartAKV &&*/ shoppingCartCount >= 1">
                        <v-card outlined color="grey lighten-5" class="mb-5 elevetation-6">
                            <v-expansion-panels :value="0">
                                <v-expansion-panel class="secondary white--text">
                                    <v-expansion-panel-header>
                                        <div><span v-if="shoppingCartAKV && shoppingCartCount == 1">Enter Active & Creative Kids / </span> {{ appNameUrls.client }} Voucher</div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-card>
                                            <v-card-text>
                                                <coupon :grand-total="subTotal" :akv="shoppingCartAKV" @submitted-voucher="submittedVoucher"></coupon>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card>
                        <v-btn color="primary" @click="submitStep('step'+lastStep)">Continue</v-btn>
                        <v-btn color="error" text @click.native="checkoutStep = 4">Back</v-btn>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !paymentErrors.any()]"
                        :editable="editablePanel"
                        :complete="checkoutStep > lastStep"
                        :step="lastStep"
                        :color="checkoutStep > lastStep ? 'success' : 'primary'"
                    >
                        Make Online Payment
                        <small
                            v-if="paymentErrors.any() && !paymentErrors.has('error_response')"
                            class="caption font-weight-bold secondary--text"
                            v-html="getPaymentMessage"
                        ></small>
                        <small
                            v-if="paymentErrors.any() && paymentErrors.has('error_response')"
                            class="caption font-weight-bold secondary--text"
                            v-html="paymentErrors.get('error_response')"
                        ></small>
                    </v-stepper-step>

                    <v-stepper-content :step="lastStep">
                        <donation v-if="showCpDonation"></donation>

                        <v-card color="grey lighten-5" class="ma-2 mb-5 elevetation-6">
                            <v-card-text>
                                <component :is="ftGateway" v-if="grandTotal > 0" @submitted-pay="submitPay"></component>
                                <v-alert dense outlined v-if="grandTotal <= 0 && !paySuccess" type="info">No Payment required. Click button below to complete process.</v-alert>
                            </v-card-text>
                        </v-card>
                        <v-btn :loading="payLoading" :disabled="!validPaymentForm" color="primary" @click="payShoppingCart" class="mr-2 text-left"
                            ><v-icon left>local_atm</v-icon>{{ payHtml }}: {{ grandTotal | currency }}</v-btn
                        >
                        <v-btn v-if="grandTotal > 0" @click="clearPay" color="warning" :disabled="payLoading" class="text-left"
                            >clear
                            <v-icon right>clear</v-icon>
                        </v-btn>
                    </v-stepper-content>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

import { EventBus } from "@shared/EventBus.js";
import Eway from "@components/gateways/Eway.vue";
import MerchantWarrior from "@components/gateways/MerchantWarrior.vue";
import Coupon from "@components/coupons/Coupon.vue";
import Donation from "@components/donation/Donation.vue";

export default {
    name: "CheckoutModule",
    components: {
        eway: Eway,
        merchantWarrior: MerchantWarrior,
        coupon: Coupon,
        donation: Donation,
    },
    data() {
        return {
            checkoutStep: 1,
            editablePanel: false,
            paymentProcessing: false,

            gender: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }],
            attendees: [],
            assign: [],
            assignSize: 0,
            assignPerProduct: false,
            agreed: false,

            overlayColor: "cyan darken-2",
            overlay: false,
            overlayText: "",
            timeout: 500,
            dictionary: {
                messages: {
                    required: () => "This field is required",
                    email: () => "This field must be a valid email",
                    date_format: () => "This field must be a valid date",
                    numeric: () => "This field is number only",
                    min: () => "This field must be 10 digits",
                },
            },

            validPaymentForm: true,

            // ftGateway: process.env.MIX_FT_GATEWAY,
            ftGateway: gtwPw,
            showCpDonation: showDonation,
        };
    },
    watch: {
        shoppingCartQty(n, o) {
            if (!this.paymentProcessing) {
                this.checkoutStep = 1;
                this.editablePanel = false;

                this.attendees = [];
                this.assign = [];

                if (this.shoppingCartAKV) {
                    this.clearVoucher();
                    this.removeVoucher();
                }

                if (n == 0) {
                    this.removeVoucher();
                }
                this.clearPay();
            }
        },
        assign(n, o) {
            this.assignSize = this.assign.length;
        },
    },
    computed: {
        donationTotal() {
            return this.$store.getters["donation/donationTotal"];
        },
        discountTotal() {
            return this.$store.getters["coupon/discountTotal"];
        },
        couponApplied() {
            return this.$store.getters["coupon/couponApplied"];
        },
        couponErrors() {
            return this.$store.getters["coupon/couponErrors"];
        },
        couponLoading() {
            return this.$store.getters["coupon/couponStatus"] == "loading";
        },
        getCouponMessage() {
            return this.$store.getters["coupon/couponMessage"];
        },
        user() {
            return this.$store.getters["user/getProfile"];
        },
        isAdult() {
            return moment(this.user["dob"], "DD-MM-YYYY").isBefore(moment().subtract(18, "years"));
        },
        states() {
            return this.$store.getters["common/getData"]("states");
        },
        localities() {
            return this.$store.getters["common/getData"]("localities");
        },
        shoppingCart() {
            return this.$store.getters["product/shoppingCart"];
        },
        shoppingCartCount() {
            return this.$store.getters["product/shoppingCartCount"];
        },
        shoppingCartQty() {
            return this.shoppingCart.reduce((qtySum, item) => qtySum + (!item.product_no_attendee ? item.product_quantity : 0), 0);
        },
        minShoppingCartQty() {
            if (!_.every(this.shoppingCart, ["product_quantity", 1])) {
                let qtyMax = _.get(_.maxBy(_.filter(this.shoppingCart, function(o) { return !o.product_no_attendee; }), "product_quantity"), "product_quantity");

                return qtyMax;
            }

            return 1;
        },
        shoppingCartAKV() {
            return _.size(this.shoppingCart) == 1 && _.every(this.shoppingCart, ["product_akv", true]);
        },
        shoppingCartNoAttendee() {
            return _.every(this.shoppingCart, ["product_no_attendee", true]);
        },
        // anyShoppingCartNoAttendee() {
        //     return _.some(this.shoppingCart, ["product_no_attendee", true]);
        // },
        shoppingCartVoucher() {
            if (_.size(this.shoppingCart) >= 1) {
                return true;
            }

            return false;
        },
        attendeeSize() {
            return this.attendees.length;
        },
        lastStep() {
            this.clearVoucher();

            if (_.size(this.shoppingCart) >= 1 /*&& _.every(this.shoppingCart, ["product_akv", true])*/) {
                return 6;
            }

            return 5;
        },
        subTotal() {
            let subTotal = 0;

            for (let product of this.shoppingCart) {
                subTotal += parseFloat(product.product_totalPrice);
            }

            return parseFloat(subTotal).toFixed(2);
        },
        taxTotal() {
            return this.subTotal / (taxRate + 1);
        },
        grandTotal() {
            return this.subTotal - this.discountTotal + this.donationTotal;
        },
        paymentErrors() {
            return this.$store.getters["product/paymentErrors"];
        },
        getPaymentMessage() {
            if (this.paymentErrors.any()) {
                if (this.paymentErrors.has("error_response")) {
                    return this.paymentErrors.get("error_response");
                }

                if (this.paymentErrors.has("error_validation")) {
                    return "Attendee / Assign Data Invalid";
                }

                if (this.paymentErrors.has("error_payment")) {
                    return this.paymentErrors.get("error_payment");
                }

                return "Payment Invalid";
            }

            return "";
        },
        payLoading() {
            return this.$store.getters["product/paymentStatus"] == "loading";
        },
        paySuccess() {
            return this.$store.getters["product/paymentStatus"] == "success";
        },
        payHtml() {
            if (this.grandTotal > 0) {
                return "Pay";
            }

            return "Complete";
        },
    },
    methods: {
        submittedVoucher() {
            this.checkoutStep = 4;
        },
        removeVoucher() {
            this.$store.dispatch("coupon/removeVoucher");
        },
        clearVoucher() {
            this.$store.dispatch("coupon/clearCouponErrors");
        },
        submitStep(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.checkoutStep++;
                    if (this.checkoutStep >= this.lastStep) {
                        // this.editablePanel = true;
                    }
                }
            });
        },
        addAttendee: function(e) {
            e.preventDefault();
            let userAttendee = this.user;

            let loggedInUserAlreadyAdded = _.size(
                _.filter(this.attendees, function(o) {
                    return o.firstname == userAttendee.firstname && o.lastname == userAttendee.lastname && o.dob == userAttendee.dob && o.gender == userAttendee.gender;
                })
            );

            if (loggedInUserAlreadyAdded < 1) {
                this.attendees.push({
                    firstname: userAttendee.firstname,
                    lastname: userAttendee.lastname,
                    dob: userAttendee.dob,
                    gender: userAttendee.gender,
                    requireInfo: false,
                    status: "",
                    btn: "CONFIRM ATTENDEE",
                    confirm: false,
                    click: false,
                });
            } else {
                this.attendees.push({
                    firstname: "",
                    lastname: "",
                    dob: "",
                    gender: "",
                    requireInfo: false,
                    status: "",
                    btn: "CONFIRM ATTENDEE",
                    confirm: false,
                    click: false,
                });
            }
        },
        assignAttendee(product_id, attIndex, value) {
            this.assign.push({
                productId: product_id,
                attendeeIndex: attIndex,
                attendeeInfo: this.attendees[attIndex],
            });

            if (!value) {
                _.remove(this.assign, function(a) {
                    return a.productId == product_id && a.attendeeIndex == attIndex;
                });
            }

            var _self = this;

            _.forEach(this.shoppingCart.filter(o => !o.product_no_attendee), function(product) {
                let a = _.groupBy(_self.assign, "productId");
                // console.log(_.size(a[product.product_id]));
                // console.log(product.product_quantity);
                if (_.size(a[product.product_id]) == product.product_quantity) {
                    _self.assignPerProduct = true;
                } else {
                    // console.log('Assign attendees do not match products quantity purchased');
                    _self.assignPerProduct = false;
                    return false;
                }
            });

            this.assignSize = this.assign.length;
        },
        viewAssignAttendee(product_id) {
            if (_.size(this.assign)) {
                let prodAtt = _.map(this.assign, function(p) {
                    if (p.productId == product_id) {
                        return [p.attendeeInfo.firstname + " " + p.attendeeInfo.lastname];
                    }
                });

                return _.trim(_.join(prodAtt, ", "), ", ");
            }
        },
        removeAttendee: function(index) {
            this.attendees.splice(index, 1);
            this.overlay = true;
            this.overlayText = "Attendee removed";
            this.overlayColor = "primary";

            setTimeout(() => {
                this.overlay = false;
            }, this.timeout);
        },
        checkAttendee: function(index) {
            if (this.attendees[index].firstname && this.attendees[index].lastname && this.attendees[index].dob && this.attendees[index].gender) {
                let attendeeData = this.attendees;
                let hasDuplicateAttendees = _.size(
                    _.filter(this.attendees, function(o) {
                        return (
                            o.firstname == attendeeData[index].firstname &&
                            o.lastname == attendeeData[index].lastname &&
                            o.dob == attendeeData[index].dob &&
                            o.gender == attendeeData[index].gender
                        );
                    })
                );
                if (hasDuplicateAttendees <= 1) {
                    this.$store
                        .dispatch("product/checkAttendee", {
                            attendee: this.attendees[index],
                        })
                        .then(resp => {
                            this.attendees[index].confirm = true;
                            this.attendees[index].click = true;
                            // this.attendees[index].requireInfo = false;
                            this.attendees[index].status = resp.data;
                            this.attendees[index].btn = "ATTENDEE ADDED";

                            this.overlay = true;
                            this.overlayColor = "primary";
                            this.overlayText = "Attendee added";

                            setTimeout(() => {
                                this.overlay = false;
                            }, this.timeout);
                        })
                        .catch(err => {
                            this.attendees[index].click = false;
                            this.attendees[index].requireInfo = true;
                            this.attendees[index].confirm = false;

                            // if(err == 'Attendee info required'){
                            //     this.attendees[index].requireInfo = true;
                            // }

                            this.attendees[index].status = err;
                        });
                } else {
                    this.overlay = true;
                    this.overlayText = "Attendee already added";
                    this.overlayColor = "error";
                }
            }
        },
        removeProduct(product) {
            this.$store.dispatch("product/removeProductFromCart", product);
        },
        removeProductQuantity(product) {
            this.$store.dispatch("product/removeProductQuantityToCart", product);
        },
        addProductQuantity(product) {
            this.$store.dispatch("product/addProductQuantityToCart", product);
        },
        addProduct(product) {
            this.$store.dispatch("product/addProductToCart", product);
        },
        showVoucherEligibility(eligible) {
            if (eligible) {
                return 'Eligible for Active & Creative Kids <i class="fa fa-check-circle" aria-hidden="true"></i>';
            }

            return 'Not eligible for Active & Creative Kids <i class="fa fa-times-circle" aria-hidden="true"></i>';
        },
        showAttendeeEligibility(eligible) {
            if (eligible) {
                return 'No Attendee required <i class="fa fa-times-circle" aria-hidden="true"></i>';
            }

            return 'Attendee required <i class="fa fa-check-circle" aria-hidden="true"></i>';
        },
        clearPay: function() {
            EventBus.$emit("clear-pay");

            this.$store.dispatch("product/clearPaymentErrors");
        },
        payShoppingCart: function() {
            if (this.grandTotal > 0) {
                EventBus.$emit("submit-pay");
            } else {
                this.submitPay();
            }
        },
        submitPay: function(payload) {
            this.validPaymentForm = false;
            this.paymentProcessing = true;

            const attendees = this.attendees;
            const assign = this.assign;
            const cardPayload = payload;
            const couponCart = this.$store.getters["coupon/couponCart"];
            const donationCart = this.$store.getters["donation/donationCart"];

            this.$store
                .dispatch("product/payShoppingCart", {
                    attendees: attendees,
                    assign: assign,
                    cardPayload: cardPayload,
                    couponCart: couponCart,
                    donationCart: donationCart,
                })
                .then(order_id => {
                    this.overlayText = "Payment was successful.";
                    this.overlay = true;
                    this.overlayColor = "primary";
                    this.membReq = true;

                    if (this.shoppingCartAKV) {
                        this.clearVoucher();
                    }
                    // console.log(order_id);

                    setTimeout(() => {
                        // this.$store
                            // .dispatch("order/orderRequest")
                            // .then(() => {
                                this.$router.push({
                                    name: "orderDetail",
                                    params: { order_id: order_id },
                                });
                            // })
                            // .catch();
                    }, this.timeout / 4);
                })
                .catch(err => {
                    this.validPaymentForm = true;
                    this.paymentProcessing = false;
                    // console.log(err);

                    setTimeout(() => {
                        EventBus.$emit("clear-pay");
                    }, 500);
                });
        },
        setLocation(suburb, index) {
            if (suburb) {
                let locality = [];

                locality = this.localities.filter(function(object) {
                    return object.value == suburb;
                })[0];

                this.attendees[index].postcode = locality.postcode;
                this.attendees[index].state = locality.state;
                this.errors.remove("attendee.suburb_" + index);
                this.errors.remove("attendee.postcode_" + index);
                this.errors.remove("attendee.state_" + index);
            }
        },
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    beforeCreate() {
        this.$store.dispatch("user/userRequest");

        if (_.isEmpty(this.$store.getters["common/getData"]("localities"))) {
            this.$store.dispatch("common/dataRequest", { type: "localities" });
        }

        if (_.isEmpty(this.$store.getters["common/getData"]("states"))) {
            this.$store.dispatch("common/dataRequest", { type: "states" });
        }
    },
};
</script>

<style lang="scss" scoped>
.upd_qty {
    min-width: 25px !important;
    padding: 0 0px !important;
    height: 20px !important;
    margin-left: 5px !important;
}

.v-list-item__icon {
    margin: 10px 0;
}
</style>
